/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useMutation, ApolloError } from '@apollo/client';
import { useSessionContext } from '@exo/frontend-common-session-context';
import { parseTokenExpiryTime } from '@exo/frontend-common-app-identity-and-access';
import { v4 as uuidv4 } from 'uuid';

const AUTHENTICATE = gql`
  mutation Auth($username: String!, $password: String!, $isOTP: Boolean!) {
    authLogin(username: $username, password: $password, isOTP: $isOTP) {
      token
      expiresAt
      isPasswordExpired
    }
  }
`;

export const useVerifyOTPToken = () => {
  const session = useSessionContext();
  const [authenticate, { loading: verifyLoading }] = useMutation(AUTHENTICATE);

  const verifyOTPToken = async (otpToken: string, otpCode: string, email?: string) => {
    try {
      const res = await authenticate({
        variables: {
          username: otpToken,
          password: otpCode,
          isOTP: true
        }
      });

      session.update({
        token: res.data.authLogin.token,
        tokenExpiryTime: parseTokenExpiryTime(res.data.authLogin.expiresAt),
        username: email || otpToken,
        firstName: '',
        clientId: uuidv4(),
        type: 'USER',
        roles: ['user']
      });

      return {
        success: true,
        token: res.data.authLogin.token
      };
    } catch (error) {
      const apolloError = error as ApolloError;
      const graphQLError = apolloError?.graphQLErrors?.[0];
      const errorCode = graphQLError?.extensions?.code;
      const errorMessage = graphQLError?.message;

      return {
        success: false,
        error: {
          code: errorCode,
          message: errorMessage || 'Please provide a correct code.'
        }
      };
    }
  };

  return {
    verifyOTPToken,
    verifyLoading
  };
};
